import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import prjAuth from "@/utils/auth/prjAuth";
import mainAuth from "@/utils/auth/mainAuth";
import deviceAuth from "@/utils/auth/deviceAuth";
Vue.use(VueRouter);
import Layout from "@/components/layout";

const routes = [

  {
    path: "/Login",
    component: () => import("@/views/Login"),
    meta: {
      title: "前台登录",
    },
  },
  {
    path: "/",
    component: () => import("@/views/homePage"),
    meta: {
      title: "前台登录",
    },
  },
  {
    path: "/adminLogin",
    component: () => import("@/views/admin/Login"),
    // redirect: 'noredirect',
    meta: {
      title: "管理后台登录",
    },
  },
  {
    path: "/admin",
    component: () => import("@/views/admin/Index"),
    redirect: "/admin/index",
    meta: {
      title: "管理后台登录",
    },
    children: [
      {
        path: "index",
        component: () => import("@/views/admin/Home"),
        meta: {
          title: "后台主页",
        },
      },
      {
        path: "project",
        component: () => import("@/views/admin/Project"),
        meta: {
          title: "项目管理",
        },
      },
      {
        path: "device",
        component: () => import("@/views/admin/Device"),
        meta: {
          title: "设备管理",
        },
      },
      {
        path: "user",
        component: () => import("@/views/admin/User"),
        meta: {
          title: "用户管理",
        },
      },
      {
        path: "product",
        component: () => import("@/views/admin/Product"),
        meta: {
          title: "产品型号",
        },
      },
      {
        path: "ver",
        component: () => import("@/views/admin/Ver"),
        meta: {
          title: "系统管理",
        },
      },
      {
        path: "task",
        component: () => import("@/views/admin/Task"),
        meta: {
          title: "任务管理",
        },
      },
      {
        path: "log",
        component: () => import("@/views/admin/Log"),
        meta: {
          title: "系统日志",
        },
      },
      {
        path: "DetectionRecord",
        component: () => import("@/views/admin/DetectionRecord"),
        meta: {
          title: "检测记录",
        },
      },
      {
        path: "homeowner",
        component: () => import("@/views/admin/Homeowner"),
        meta: {
          title: "厂家管理",
        },
      },
      {
        path: "template",
        component: () => import("@/views/admin/Template"),
        meta: {
          title: "模板管理",
        },
      },
    ],
  },
  {
    path: "/protocol",
    component: Layout,
    redirect: "/",
    children: [
      {
        path: "search",
        component: () => import("@/views/protocol/Search"),
        meta: {
          title: "协议库搜索",
        },
      },
      {
        path: "upload",
        component: () => import("@/views/protocol/Upload"),
        meta: {
          title: "协议库上传",
        },
      },
      {
        path: "login",
        component: () => import("@/views/protocol/Login"),
        meta: {
          title: "协议库登录",
        },
      },
    ],
  },
  {
    path: "/home",
    component: () => import("@/views/Home.vue"),
    meta: {
      title: "前台主页",
    },
  },
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_SRC,
  routes,
});

function loadView(view) {
  if (process.env.NODE_ENV === "development") {
    return (resolve) => require([`@/views/${view}`], resolve);
  } else {
    // 使用 import 实现生产环境的路由懒加载
    return () => import(`@/views/${view}`);
  }
}

//可以通过的白名单
let registerRouteFresh = true;
const whiteList = ["/", "/adminLogin"];
router.beforeEach((to, from, next) => {
  next();
  //   if (to.path == '/' || to.path == '/adminLogin') {
  //     // 在免登录白名单，直接进入
  //     next()
  //   } else {
  //     if (store.state.user.userInfo && Object.values(store.state.user.userInfo).length > 0 && registerRouteFresh) {
  //       let routerList = []
  //       if (store.getters.Role == 2) {
  //         prjAuth.forEach(item => {
  //           this.$router.addRoute('admin', {
  //             path: item.path,
  //             component: loadView(item.component),
  //             meta: {
  //               title: item.title
  //             }
  //           })
  //         });
  //       } else {
  //         mainAuth.forEach(item => {
  //           this.$router.addRoute('admin', {
  //             path: item.path,
  //             component: loadView(item.component),
  //             meta: {
  //               title: item.title
  //             }
  //           })
  //         });
  //       }
  //       registerRouteFresh = false
  //       next({
  //         ...to,
  //         replace: true
  //       })
  //     } else {
  //       next(`/?redirect=${to.fullPath}`) // 否则全部重定向到登录页
  //     }
  //   }
});
export default router;
